import React, { useState } from "react";
import { COMPANY } from "@/lib/company";
import { imgSrc } from "@/lib/media";

export const VehiclePlaceholder = ({ vehicle, size = "card" }) => (
  <div data-testid="vehicle-image-placeholder"
    className="placeholder-sheen absolute inset-0 overflow-hidden bg-[radial-gradient(120%_90%_at_50%_0%,#ffffff_0%,rgb(var(--c-elevated))_55%,rgb(var(--c-line))_100%)] flex flex-col items-center justify-center text-center px-6">
    {(COMPANY.logoDark || COMPANY.logo) && (
      <img src={COMPANY.logoDark || COMPANY.logo} alt="" aria-hidden="true"
        className={`${size === "large" ? "h-20 md:h-24" : "h-12"} w-auto opacity-[0.14] grayscale mb-5`} />
    )}
    <p className="text-[10px] uppercase tracking-[0.35em] text-faint font-semibold">{vehicle.brand}</p>
    <p className={`font-display font-bold chrome-text mt-1.5 leading-tight ${size === "large" ? "text-3xl md:text-5xl" : "text-2xl"}`}>
      {vehicle.model}
    </p>
    <span className="mt-4 inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-dim border border-line bg-surface/70 rounded-full px-3 py-1">
      <span className="w-1.5 h-1.5 rounded-full bg-brand" /> Fotos folgen in Kürze
    </span>
  </div>
);

export const VehicleImage = ({ vehicle, idx = 0, size = "card", className = "", testId }) => {
  const [failed, setFailed] = useState(false);
  const src = vehicle.images?.[idx];
  if (!src || failed) return <VehiclePlaceholder vehicle={vehicle} size={size} />;
  return (
    <img src={imgSrc(src, size)} alt={vehicle.title} loading={size === "large" ? "eager" : "lazy"} decoding="async"
      data-testid={testId} onError={() => setFailed(true)} className={`absolute inset-0 w-full h-full object-cover ${className}`} />
  );
};

export default VehicleImage;
